import React, { useState, } from "react";
import { fetchAddressAreaByPin } from "../../service/AddressApi";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import PropTypes from "prop-types";

const AddressSelection = ({ onAddressChange, addressType }) => {
  useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [selectedSubareaId, setSelectedSubareaId] = useState(null);
  const [addressAreas, setAddressAreas] = useState({});
  const [pincode, setPincode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // Handle the area selection
  const handleAreaChange = (e) => {
    const selectedId = e.target.value;
    setSelectedAreaId(selectedId);
    setSelectedSubareaId(null); // Reset subarea selection when area changes
    triggerAddressChange(selectedId, null);
  };

  // Handle subarea selection
  const handleSubareaChange = (e) => {
    const selectedId = e.target.value;
    setSelectedSubareaId(selectedId);
    triggerAddressChange(selectedAreaId, selectedId);
  };

  // Trigger address change with all relevant data
  const triggerAddressChange = (areaId, subareaId) => {
    onAddressChange(addressType, areaId, subareaId,
    );
  };


  // Load address areas based on the entered pincode
  const loadAddressAreas = async () => {
    if (!pincode.match(/^\d{6}$/)) {
      setErrorMessage("6 இலக்க பின்கோடை உள்ளிடவும்");
      return;
    }

    setLoading(true);
    setSelectedAreaId(null);
    setSelectedSubareaId(null);

    try {
      const data = await fetchAddressAreaByPin(pincode,'true'); // Fetch the data
      if (data && data.addressAreaList && Array.isArray(data.addressAreaList)) {
        setAddressAreas(data);
      } else {
        setAddressAreas({});
        setErrorMessage('இந்த பின்கோடுக்கு முகவரிப் பகுதிகள் எதுவும் கிடைக்கவில்லை.');
      }
    } catch (error) {
      setErrorMessage("முகவரிப் பகுதிகளைப் பெறுவதில் பிழை.");
      console.error("Error fetching address areas:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <hr />
      <label className="auth_label">{addressType === 'temp' ? 'தற்காலிக முகவரி' : 'நிரந்தர முகவரி'}</label>

      {/* Pincode Input */}
      <div className="auth_element">
        <label className="auth_label">பின்கோடு</label>
        <input
          type="text"
          id="pincode"
          value={pincode}
          onChange={(e) => setPincode(e.target.value)}
          className="auth_input"
          placeholder="பின்கோடை உள்ளிடவும்"
          autoComplete="off"
          inputMode="numeric"
          maxLength="6"
        />
        <button type="button" onClick={loadAddressAreas} disabled={loading}>
          {loading ? "ஏற்றுகிறது..." : "முகவரிப் பகுதிகளை ஏற்று"}
        </button>
        {errorMessage && <div className="auth_error">{errorMessage}</div>}
        <br />
      </div>

      {/* Address Area Selection */}
      {addressAreas?.addressAreaList?.length > 0 && (
        <div className="auth_element" style={{ marginBottom: '20px' }}>
          <select
            value={selectedAreaId || ""}
            onChange={handleAreaChange}
            className="auth_select"
          >
            <option value="" disabled>பகுதியைத் தேர்ந்தெடுக்கவும்</option>
            {addressAreas.addressAreaList.map((area) => (
              <option key={area.id} value={area.id}>
                {`${area.name_tamil || area.name}, ${area.block_tamil || area.block}, ${area.district_tamil || area.district}`}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Subarea Selection */}
      {selectedAreaId && (
        <div className="auth_element" style={{ marginTop: '20px' }}>
          <label>ஊரைத் தேர்ந்தெடுக்கவும்:</label>
          {addressAreas?.addressAreaList.find((area) => area.id === selectedAreaId)?.subAreas?.length > 0 ? (
            <select
              value={selectedSubareaId || ""}
              onChange={handleSubareaChange}
              className="auth_select"
            >
              <option value="" disabled>ஒரு ஊரைத் தேர்ந்தெடுக்கவும்</option>
              {addressAreas.addressAreaList
                .find((area) => area.id === selectedAreaId)
                ?.subAreas.map((subarea) => (
                  <option key={subarea.id} value={subarea.id}>
                    {(
                      (subarea.name_tamil || subarea.name)  // Check if either exists
                    ) ?
                      ((subarea.name_tamil || subarea.name)  // If it exists, process it
                        .split('|')                           // Split by "|"
                        .reverse()                            // Reverse the array
                        .map((token) => token.trim())      // Trim each token for any extra spaces
                        .join(', ')                           // Join with commas
                      )
                      : 'ஊர் கிடைக்கவில்லை'  // Default message if neither exists
                    }
                  </option>
                ))}
            </select>
          ) : (
            <p>இந்தப் பகுதிக்கு எந்த இடமும் கிடைக்கவில்லை...</p>
          )}
        </div>
      )}
    </div>
  );
};

// PropTypes validation
AddressSelection.propTypes = {
  onAddressChange: PropTypes.func.isRequired, // Ensure onAddressChange is a function and required
  addressType: PropTypes.string.isRequired,   // Ensure addressType is a string and required
};

export default AddressSelection;
